export default "__VITE_ASSET__DwvziXre__"